if (!customElements.get("pro-shipping-countdown")) {
  customElements.define(
    "pro-shipping-countdown",
    class ProShippingCountdown extends HTMLElement {
      connectedCallback() {
        this._display = this.querySelector(".pro-shipping-countdown__time");
        if (!this._display) return;

        const clamp = (n, lo, hi) => Math.min(hi, Math.max(lo, n));
        const hours = clamp(parseInt(this.dataset.hours, 10) || 0, 0, 168);
        const minutes = clamp(parseInt(this.dataset.minutes, 10) || 0, 0, 59);
        const seconds = clamp(parseInt(this.dataset.seconds, 10) || 0, 0, 59);
        const totalMs =
          (hours * 3600 + minutes * 60 + seconds) * 1000;

        this._endTime = Date.now() + totalMs;

        this._tick = () => {
          const diff = this._endTime - Date.now();
          if (diff <= 0) {
            this._display.textContent = "00:00:00";
            if (this._intervalId != null) {
              clearInterval(this._intervalId);
              this._intervalId = null;
            }
            return;
          }
          const totalSec = Math.floor(diff / 1000);
          const h = Math.floor(totalSec / 3600);
          const m = Math.floor((totalSec % 3600) / 60);
          const s = totalSec % 60;
          this._display.textContent = `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
        };

        this._tick();
        this._intervalId = setInterval(this._tick, 1000);
      }

      disconnectedCallback() {
        if (this._intervalId != null) {
          clearInterval(this._intervalId);
          this._intervalId = null;
        }
      }
    }
  );
}
